// extracted by mini-css-extract-plugin
module.exports = {"Header":"styles_Header__2nzq9","List":"styles_List__1LbEq","Item":"styles_Item__1RBOP"};